<template>
    <a class="tts-btn" role="button" href="javascript:void(0)" @click="ttsClick($event.target)" :aria-label="$t('message.play-tts')" tabindex="0"><img
            class="pointer speaker-image inflection normal"
            :alt="$t('message.speech-synthesis_icon')"
            src="/images/speaker-small-inflection.svg"
        ></a>
</template>

<script>
export default {
	 name: 'SpeakTextContent',
	 data(){
        return {
            'counter': 0,
        }
    },
	props:{
         type: {
             required: false,
             default: "div"
         }
	},
	mounted(){
	},
	methods:{
        ttsClick(clickedEl) {
            let el = clickedEl.closest(this.type);
            if (el) {
                $(el).find('span').each(function (){
                    let elId = $(this).attr('id');
                    if (elId) {
                        let hideElementList = document.getElementsByClassName("speakTextHidden");
                        for (let i=0; i<hideElementList.length; i++) {
                            hideElementList[i].style = "display: none;";
                        }

                        let elHiddenId = elId + "-hidden";
                        let elHidden = document.getElementById(elHiddenId);
                        if (!elHidden) {
                            elHidden = document.createElement("div");
                            elHidden.id = elHiddenId;
                            elHidden.className = "speakTextHidden";
                            elHidden.innerHTML = this.innerHTML;
                            document.body.appendChild(elHidden);
                        }

                        elHidden.style = "display: block;";
                        setTimeout(function (){
                            elHidden.style = "display: none;"
                        }, 5000);

                        if (typeof vFact_playsection_or_selection === "function") {
                            // vFact_playsection_or_selection(elHiddenId);
                            vFact_playsection_or_selection(elId);
                        }
                    }
                });
            }
        }
    },
    computed: {
    }
}
</script>
